import { makeStyles } from 'tss-react/mui';

export const useReviewViewStyles = makeStyles()((theme) => ({
  saveButton: {
    textAlign: 'right',
    textTransform: 'uppercase',
    marginTop: '2rem',
  },
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  confirmPaper: {
    width: '100%',
    marginTop: '2rem',
    padding: theme.spacing(2),
  },
}));
